import tw, { styled } from 'twin.macro'
import React from 'react'
import PropTypes from 'prop-types'
import { navbarLinkStyles } from './NavbarLink'

const Wrapper = styled('div')`
  ${tw`relative`};
`

const LinkWrapper = styled('div')`
  ${tw`inline-block select-none`};
`

const LinkTitle = styled('div')`
  ${tw`appearance-none flex items-center inline-block`}
`

const DropdownWrapper = styled('div')`
  ${tw`lg:absolute right-0 w-full lg:mt-2`};

  ${props => props.visible ? '': tw`hidden`}
`

const DropdownContainer = styled('div')`
  ${tw`bg-white shadow rounded border overflow-hidden w-64`}
`

const Dropdown = ({ children, title, showDropdown, onDropdownToggle }) => (
  <Wrapper>
    <LinkWrapper role="button" onClick={onDropdownToggle}>
      <LinkTitle css={navbarLinkStyles} style={{ marginTop: 0, marginBottom: 0 }}>
        {title} <i className="fa fa-angle-down" />
      </LinkTitle>
    </LinkWrapper>
    <DropdownWrapper visible={showDropdown}>
      <DropdownContainer>{children}</DropdownContainer>
    </DropdownWrapper>
  </Wrapper>
)

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  showDropdown: PropTypes.bool.isRequired,
  onDropdownToggle: PropTypes.func.isRequired,
}

export default Dropdown
